import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import { getAuthors } from '../lib/api';

function Autores() {
  const [authors, setAuthors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAuthors()
      .then((data) => setAuthors(data.authors))
      .catch(() => setAuthors([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page">
      <Seo title="Autores" description="Autores reseñados y recomendados en Libros para Viajeros." />
      <h1>Autores</h1>
      {!loading && authors.length === 0 && <p className="empty-state">Todavía no hay autores publicados.</p>}
      <div className="card-grid">
        {authors.map((author) => (
          <Link key={author.id} to={`/autores/${author.slug}`} className="content-card">
            {author.photo_url && <img src={author.photo_url} alt={author.name} />}
            <div className="content-card__body">
              <h3 className="content-card__title">{author.name}</h3>
              {author.country && <p className="content-card__excerpt">{author.country}</p>}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Autores;
